import styled from 'styled-components';
import ExpandDownIcon from '../../assets/images/expand-down.svg';

const ExpandUp = styled.span`
  background: url(\"${ExpandDownIcon}\") no-repeat left center;
  background-size: 14px 8px;
  display: block;
  position: relative;
  width: 14px;
  height: 8px;
  transform: rotate(180deg);
`;

export default ExpandUp;
